import { TCompanyState } from './types'

export default {
  loading: false,
  company: null
} as TCompanyState
